import { gql } from '@apollo/client';
import client from 'graphql/client';

const fetchCandidateSearchRole = () => {
  const query = gql`
    query canidateSearchRole {
      candidateSearchRole
    }
  `;

  return client.query({
    query,
    fetchPolicy: 'network-only',
  });
};

export default fetchCandidateSearchRole;
